module.exports = __webpack_public_path__ + "static/media/pk_360_serv.33457c05.jpg";